import store from "../../../../../redux/store";

export const isActiveBusinessArea = ({ buLabel = null, buId, isCentralizedAdmCase = false }) => {
  const { allBusinessAreaList } = store.getState().globalData.masterDropdowns;
    if(isCentralizedAdmCase) return true
  const buDetails = buLabel
    ? allBusinessAreaList.filter((bu) => bu.label === buLabel)[0]
    : allBusinessAreaList.filter((bu) => bu.businessAreaId === buId)[0];
  console.log(buDetails)
  return buDetails?.status === "ACTIVE" || false;
};


export  const isAxisBankEnabled = (availableFeatureList = [])=>{
 return  availableFeatureList.some(item=>item?.feature?.toLowerCase()?.includes("axis"))
}
